import React, { useEffect } from 'react'

import { Box, Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { Barcode } from 'src/components/Barcode'

import { convertGS1 } from './utils'

const useStyles = makeStyles({
  label: {
    width: '4in',
    height: '6in',
  },
  zoneA: {
    borderRight: '1px solid black',
    borderBottom: '1px solid black',
    height: '1in',
    width: '1.5in',
    fontSize: '14px',
  },
  zoneB: {
    borderLeft: '1px solid black',
    borderBottom: '1px solid black',
    height: '1in',
    width: '2.5in',
    fontSize: '14px',
  },
  zoneE: {
    borderTop: '1px solid black',
    borderBottom: '1px solid black',
    height: '1in',
    width: '4in',
  },
  zoneF: {
    borderTop: '1px solid black',
    borderBottom: '1px solid black',
    height: '1in',
    width: '4in',
  },
  zoneG: {
    borderTop: '1px solid black',
    borderRight: '1px solid black',
    borderBottom: '1px solid black',
    height: '1in',
    width: '2in',
  },
  zoneH: {
    borderTop: '1px solid black',
    borderLeft: '1px solid black',
    borderBottom: '1px solid black',
    height: '1in',
    width: '2in',
  },
  zoneI: {
    borderTop: '1px solid black',
    height: '1in',
    width: '4in',
  },
  header: {
    fontSize: '12px',
    fontWeight: 'bold',
    paddingLeft: '3px',
  },
  address: {
    lineHeight: '1.0',
    paddingLeft: '10px',
  },
  from: {
    lineHeight: '1.0',
    paddingLeft: '5px',
    fontSize: '10px',
  },
  carrier: {
    fontWeight: 'bold',
    paddingLeft: '5px',
  },
  to: {
    lineHeight: '1.0',
    fontWeight: 'bold',
    paddingLeft: '10px',
  },
  container: {
    top: 'auto',
    bottom: 0,
  },
  center: {
    flexGrow: 1,
    textAlign: 'center',
  },
})

interface TractorSupplyLabelProps {
  zoneA: string[]
  zoneB: string[]
  zoneE: string
  zoneF: string
  zoneG: number[]
  zoneH: string
  zoneI: string
}

interface Props {
  data: TractorSupplyLabelProps
  onReadyToPrint?: () => void
}

export const TractorSupplyLabel = (props: Props) => {
  const { data, onReadyToPrint } = props
  const ssccBarcode = { barcode: convertGS1(data.zoneI, 2), type: 'gs1-128', displayName: '' }
  const poBarcode = { barcode: data.zoneE, type: 'code128', displayName: '' }
  const classes = useStyles()

  useEffect(() => {
    onReadyToPrint?.()
  }, [onReadyToPrint])

  return (
    <div className={`always-page-break ${classes.label}`}>
      <div className="print-page">
        <Box className={classes.label}>
          <Grid container spacing={0}>
            <Grid item>
              <Box className={classes.zoneA}>
                <Typography className={classes.header}>From:</Typography>
                {data.zoneA.map((line) => (
                  <Typography key={line} className={classes.from}>
                    {line}
                  </Typography>
                ))}
              </Box>
            </Grid>
            <Grid item>
              <Box className={classes.zoneB}>
                <Typography className={classes.header}>To:</Typography>
                {data.zoneB.map((line) => (
                  <Typography key={line} className={classes.to}>
                    {line}
                  </Typography>
                ))}
              </Box>
            </Grid>
            <Grid item>
              <Box className={classes.zoneE}>
                <Typography className={classes.header}>PO Number:</Typography>
                <Box display="flex" justifyContent="center" mt={0} pt={0}>
                  <Typography variant="h6">{poBarcode.barcode}</Typography>
                </Box>
                <Box ml={20} mr={20}>
                  <Barcode barcode={poBarcode} scale={2} height={7} />
                </Box>
              </Box>
            </Grid>
            <Grid item>
              <Box display="flex" alignItems="center" justifyContent="center" className={classes.zoneF}>
                <Typography variant="h5">{data.zoneF}</Typography>
              </Box>
            </Grid>
            <Grid item>
              <Box className={classes.zoneG} display="flex" alignItems="center" justifyContent="center">
                <Typography variant="h2">
                  {data.zoneG[0]} of {data.zoneG[1]}
                </Typography>
              </Box>
            </Grid>
            <Grid item>
              <Box
                className={classes.zoneH}
              >
                <Typography className={classes.header}>STORE:</Typography>
                <Box pl={3}>
                  <Typography variant="h1">{data.zoneH}</Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item>
              <Box className={`${classes.zoneI} ${classes.container}`}>
                <Typography className={classes.header}>SSCC-18</Typography>
                <Box display="flex" justifyContent="center">
                  <Typography variant="h3">{ssccBarcode.barcode}</Typography>
                </Box>
                <Box ml={5} mr={5}>
                  <Barcode barcode={ssccBarcode} scale={2} height={20} />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </div>
    </div>
  )
}
